export enum Consumer {
  RECEIVED_UI = 'RECEIVED_UI',
  RECEIVED_SERVER = 'RECEIVED_SERVER',
}
